// removed by extract-text-webpack-plugin
module.exports = {"image_slide":"-image_slide__3ll_R-","active_slide":"-active_slide__1FAqp-"};